import {
  Box,
  Button,
  FormLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import theme from "../theme";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../styles/useButtonStyles";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import useFormStyles from "../styles/useFormStyles";
import CloseIcon from "@mui/icons-material/Close";

interface FraudProps {
  closeDrawer?: Function;
}
const FraudDetectSettings = (props: FraudProps) => {
  const { closeDrawer } = props;
  const formStyles = useFormStyles();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const buttonStyles = useButtonStyles();
  const [fraudDetails, setFraudDetails] = useState([]);
  const [receipt_amount, setReceiptAmount] = useState<string>("");
  const [multiple_receipts_store, setMultipleReceiptsStore] =
    useState<string>("");
  const [multiple_receipts_calender, setMultipleReceiptsCalender] =
    useState<string>("");
  const [spending_amount, setSpendingAmount] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [addLoading, setAddLoading] = useState<boolean>(false);
  const [cutoff_config, setCutOffDate] = useState<Dayjs | null>(
    dayjs(new Date())
  );

  useEffect(() => {
    const fetchFraudDetectList = async () => {
      setAddLoading(true);
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            APIConstants.getFraudDetection +
            `?module=receipts&feature=fraud_detect_configuration`
        );
        const data = response.data.result;
        const dataArray: any = [data];
        setFraudDetails(dataArray);
      } catch (error) {
        console.error(error);
      } finally {
        setAddLoading(false);
      }
    };

    fetchFraudDetectList();
  }, []);

  useEffect(() => {}, [addLoading]);
  const handleSubmit = async (type: string) => {
    let formData: any = {};
    formData.module = "receipts";
    formData.feature = "fraud_detect_configuration";

    if (receipt_amount !== "" && +receipt_amount !== 0) {
      formData.receipt_amount = +receipt_amount;
    }

    if (spending_amount !== "" && +spending_amount !== 0) {
      formData.spending_amount = +spending_amount;
    }

    if (
      multiple_receipts_calender !== "" &&
      +multiple_receipts_calender !== 0
    ) {
      formData.multiple_receipts_calender = +multiple_receipts_calender;
    }

    if (multiple_receipts_store !== "" && +multiple_receipts_store !== 0) {
      formData.multiple_receipts_store = +multiple_receipts_store;
    }
    if (type === "cutoff") formData = { cutoff_config: cutoff_config };
    setLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.saveFraudDetection,
        formData
      );

      const responseData = response.data;
      const transformedResponse = {
        receipt_amount: responseData.receipt_amount,
        multiple_receipts_calender: responseData.multiple_receipts_calender,
        spending_amount: responseData.spending_amount,
        multiple_receipts_store: responseData.multiple_receipts_store,
        cutoff_config: responseData.cutoff_config,
      };
      const dataArray: any = [transformedResponse];
      setFraudDetails(dataArray);
    } catch (error) {
      setUploadError(true);
    } finally {
      setShowModal(true);
      setLoading(false);
    }
  };

  return (
    <>
      <Grid
        width={"100%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        height={"15%"}
        px={4}
        gap={2}
        sx={{ background: theme.color?.background }}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Fraud Detect Configuration
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      {addLoading ? (
        <Grid py={2} width={"100%"} display={"flex"} justifyContent={"center"}>
          <Loader />
        </Grid>
      ) : (
        fraudDetails.length > 0 &&
        fraudDetails.map((data: any, index) => {
          return (
            <>
              <Grid
                container
                sx={{
                  background: theme.color?.background,
                }}
                height={"85%"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                px={4}
              >
                <Grid display={"flex"} flexDirection={"column"} gap={2}>
                  <Grid display={"flex"} gap={3}>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableHeader,
                        }}
                        height={"50%"}
                        width={"70%"}
                      >
                       Multiple transactions from one store within the same day
                      </Typography>
                      <TextField
                        size="small"
                        key={index}
                        onChange={(e) =>
                          setMultipleReceiptsStore(e.target.value)
                        }
                        defaultValue={data?.multiple_receipts_store}
                        sx={{ width: "100%" }}
                        id="outlined"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableHeader,
                        }}
                        height={"50%"}
                      >
                       Multiple transactions from one store within a calendar month
                      </Typography>
                      <TextField
                        size="small"
                        key={index}
                        onChange={(e) =>
                          setMultipleReceiptsCalender(e.target.value)
                        }
                        defaultValue={data?.multiple_receipts_calender}
                        sx={{ width: "100%" }}
                        id="outlined"
                        type="text"
                      />
                    </Grid>
                  </Grid>
                  <Grid display={"flex"} gap={3}>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableHeader,
                        }}
                        height={"50%"}
                      >
                        Transaction amount is greater than (S$)
                      </Typography>
                      <TextField
                        size="small"
                        key={index}
                        onChange={(e) => setReceiptAmount(e.target.value)}
                        defaultValue={data?.receipt_amount}
                        sx={{ width: "100%" }}
                        id="outlined"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableHeader,
                        }}
                        width={"90%"}
                      >
                      Accumulated spending within a calendar month is over (S$)
                      </Typography>
                      <TextField
                        size="small"
                        key={index}
                        onChange={(e) => setSpendingAmount(e.target.value)}
                        defaultValue={data?.spending_amount}
                        sx={{ width: "100%" }}
                        id="outlined"
                        type="text"
                      />
                    </Grid>
                  </Grid>
                  <Grid width={"48%"}>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontWeight: theme.font?.fontWeight.slightThick,
                        color: theme.color?.cutOffGrey,
                        fontSize: "12px",
                      }}
                    >
                      Note: If you will leave any field empty that condition
                      will be eliminated from receipt fraud detect.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  display={"flex"}
                  gap={2}
                  justifyContent={"end"}
                  alignItems={"center"}
                  borderTop={theme.border?.newGreyBorder}
                  height={"15%"}
                >
                  <Button
                    disabled={disableSubmit}
                    sx={{
                      ...buttonStyles.outlinedSecondary,
                      width: "40%",
                    }}
                    variant="outlined"
                    onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={disableSubmit}
                    type="submit"
                    sx={{ ...buttonStyles.containedSecondary, width: "40%" }}
                    variant="contained"
                    onClick={() => handleSubmit("fraud")}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
              {showModal &&
                (uploadError ? (
                  <BasicModal
                    title={"Something went wrong"}
                    success={false}
                    setState={setShowModal}
                  />
                ) : (
                  <BasicModal
                    title={"Fraud Detect Added Successfully!"}
                    success={true}
                    setState={setShowModal}
                  />
                ))}
              {loading && <BasicModal content={<Loader />} />}
            </>
          );
        })
      )}
    </>
  );
};

export default FraudDetectSettings;
